export default {
  category: 'write',
  date: '11/23/19',
  name: 'We Ended Up Next to Each Other',
  path: '/write/we-ended-up-next-to-each-other',
  photo:
    'https://twos.s3.amazonaws.com/parkerklein/parker-klein-we-ended-up-next-to-each-other.png',
  podcastLink: '',
  youtubeLink: '',
twosLink: '',
  mediumLink: '',
  patreonLink: '',
  tags: ['Write'],
  time: 1
};
